import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "@/i18n";

// Ensures i18n language stays in sync with URL param, and sets <html lang>.
export default function useLangSync() {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    const target = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
    if (i18n.language !== target) {
      i18n.changeLanguage(target);
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = target === "ar" ? "es-AR" : "en";
    }
  }, [lang, i18n]);
}
